import RecordAudioAction from './RecordAudioAction';

export default RecordAudioAction;
